import AttachmentIcon from "@mui/icons-material/Attachment";
import React, { useState } from "react";

import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import AIIcon from "../../../assets/icons/AI-white.png";
import { useAiQualityTool } from "../../../context/AiQualityToolContext";
import { useSendAIAccuracyMutation } from "../../cargo/cargoApiSlice";
import { useGetEmailFromMailingIntegrationQuery } from "../../integrations/integrationsApiSlice";
import { AttachmentAnalyzeDialog } from "./dialog";

export const AttachmentAnalyze = ({ disabled, emailId }) => {
	const [open, setOpen] = useState(false);
	const { qualityCheck, resetQualityCheck } = useAiQualityTool();

	// no loading state needed for this mutation
	const [sendAccuracy] = useSendAIAccuracyMutation();

	const {
		data: mail,
		error: mailError,
		isLoading: isLoadingMail,
		isFetching: isFetchingMail,
	} = useGetEmailFromMailingIntegrationQuery(
		{
			emailId,
		},
		{ skip: !open }
	);

	// analyze states
	const [jobId, setJobId] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);
	const [currentStep, setCurrentStep] = useState(0);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = async (e, reason) => {
		if (reason === "backdropClick") return;
		if (reason === "escapeKeyDown") return;

		setOpen(false);
		setCurrentStep(0);
		setErrorMessage(null);
		setJobId(null);

		const { jobId, expectedFields, returnedFields, changedFields } =
			qualityCheck;

		if (jobId) {
			await sendAccuracy({
				jobId,
				data: {
					expectedFields,
					returnedFields,
					changedFields,
				},
			})
				.unwrap()
				.then(() => {
					resetQualityCheck();
				});
		}
	};

	return (
		<>
			<Tooltip
				title={
					<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
						Wyślij załącznik do AI
					</Typography>
				}
				placement="right"
			>
				<IconButton
					sx={{
						position: "relative",
						cursor: disabled ? "not-allowed" : "pointer",
					}}
					disabled={disabled}
					onClick={handleClickOpen}
				>
					<AttachmentIcon />
					<Box
						sx={{
							position: "absolute",
							top: "-2px",
							right: "-2px",
							height: "20px",
							width: "20px",
							background: "linear-gradient(to right, #61ced5, #C59AF7)",
							maskImage: `url(${AIIcon})`,
							maskSize: "20px",
							maskRepeat: "no-repeat",
						}}
					/>
				</IconButton>
			</Tooltip>
			<AttachmentAnalyzeDialog
				open={open}
				onClose={handleClose}
				attachments={Array.isArray(mail) ? mail[0]?.attachments || [] : []}
				jobId={jobId}
				setJobId={setJobId}
				errorMessage={errorMessage}
				setErrorMessage={setErrorMessage}
				currentStep={currentStep}
				setCurrentStep={setCurrentStep}
				isLoading={isLoadingMail || isFetchingMail}
			/>
		</>
	);
};
